import { getBackendUrl } from '../config/environments';

const BACKEND_URL = getBackendUrl();

/**
 * Fetch user's generation history from database
 * @param {string} walletAddress - User's wallet address
 * @param {number} limit - Number of generations to fetch (default: 50)
 * @param {number} offset - Pagination offset (default: 0)
 * @returns {Promise<{success: boolean, generations: Array}>}
 */
export async function fetchGenerationHistory(walletAddress, limit = 50, offset = 0) {
  try {
    const response = await fetch(`${BACKEND_URL}/api/ai/generations/${walletAddress}?limit=${limit}&offset=${offset}`);
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }
    
    const data = await response.json();
    return {
      success: true,
      generations: data.generations || [],
      total: data.total || 0
    };
  } catch (error) {
    console.error('Error fetching generation history:', error);
    return {
      success: false,
      error: error.message,
      generations: []
    };
  }
}

/**
 * Map database generation to view model
 * @param {Object} generation - Generation from database
 * @returns {Object} View model for frontend
 */
export function mapGenerationToViewModel(generation) {
  return {
    id: generation.id,
    url: generation.result_url, // This is the Supabase Storage URL
    prompt: generation.prompt,
    type: generation.generation_type || 'image',
    created_at: generation.created_at,
    dimensions: generation.dimensions,
    style: generation.style,
    metadata: generation.metadata || {},
    timestamp: new Date(generation.created_at).getTime() // For backward compatibility
  };
}
